var stripTags = function (str) {
    return str.replace(/(<([^>]+)>)/gi, '');
};
export default stripTags;
